import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createListReduceObject } from '../../../../../common/reducers/list/reducer';

import authUserOutputCashHistoryListSaga from './sagas/authUserOutputCashHistoryListSaga';

export default [
  // Lists
  ...createCombineMapItem(
    'authUserOutputCashHistoryList',
    createListReduceObject,
    [authUserOutputCashHistoryListSaga]
  )
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/authUserOutputCash/reducers/static/lists/reducersMap.js